<template>
  <div class="real">
    <div v-for="(item, index) in this.realTime" :key="index" class="real-time-num" > 
        <!-- //外层宽高和内层宽高要一样 -->
        <div class="real-time-num-item" :style="{transform: `translateY(-${(item) * 66}px)`}">
            <div>0</div>
            <div>1</div>
            <div>2</div>
            <div>3</div>
            <div>4</div>
            <div>5</div>
            <div>6</div>
            <div>7</div>
            <div>8</div>
            <div>9</div>
        </div>
        </div>
  </div>
</template>

<script>
export default {
    props:{
        realTimeNumber:{
            type: Number,
			default: 0
        }
    },
  data () {
    return {
        realTimeNum:0
    }
  },
  computed:{
    realTime() {
        let numberList = `${this.realTimeNumber}`.split('')
        if(numberList.length < 7){
            for(let j = 0,len = 7; j < len; j++) {
                if (numberList.length == 7) {
                     break
                }else{
                    numberList.unshift('0')
                }
            }
        }
      return numberList ||  ['0','0','0','0','0','0','0']
    },
  }
  
}
</script>
<style>
.real{
    height: 66px;
}
.real-time-num {
  display: inline-block;
  width: 38px;
  height: 66px;
  /* background:linear-gradient(0deg,rgba(36,97,147,1),rgba(115,157,191,1)); */
  /* background:linear-gradient(0deg,rgba(36,97,147,1),rgba(115,157,191,1)); */
  background:#024FFF;
  font-size: 40px;
  color: #fff;
  border-radius: 2px;
  margin-left: 5px;
  line-height: 66px;
  text-align: center;
  overflow: hidden; 
}
.real-time-num > div{
  width: 38px;
  height: 66px;
  
}
.real-time-num-item{
  transition: all 0.8s ease-out;
}
</style>


// WEBPACK FOOTER //
// src/components/dynamicDigital.vue